export const categories = [
  'Autoridade',
  'Blog',
  'Bônus',
  'Botões',
  'Comparação',
  'Contato',
  'Cronograma',
  'Depoimentos',
  'Efeitos & Códigos',
  'Elementos',
  'Faixas',
  'FAQ',
  'Forms',
  'Garantia',
  'Hero',
  'Menus',
  'Oferta',
  'Página',
  'Página de Links',
  'Para quem',
  'Prova Social',
  'Rodapés',
  'Slider / Carrossel',
  'Tabs',
  'Títulos'
];